var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4L28 28",
    stroke: "#292929",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19987 8.30663C6.6132 8.74663 6.07587 9.21063 5.58654 9.68263C3.9521 11.2696 2.59908 13.1226 1.5852 15.1626C1.45844 15.4233 1.39258 15.7094 1.39258 15.9993C1.39258 16.2892 1.45844 16.5753 1.5852 16.836C2.59855 18.8764 3.95112 20.7299 5.5852 22.3173C7.91987 24.564 11.3572 26.6666 15.9999 26.6666C18.9812 26.6666 21.4665 25.8 23.4799 24.584L18.2212 19.3266C17.4518 19.8406 16.5279 20.0719 15.607 19.9811C14.6862 19.8904 13.8253 19.4832 13.171 18.8289C12.5167 18.1746 12.1095 17.3136 12.0187 16.3928C11.9279 15.4719 12.1592 14.5481 12.6732 13.7786L7.2012 8.3053L7.19987 8.30663ZM27.5545 21.1173C28.6875 19.8192 29.6488 18.3808 30.4145 16.8373C30.5413 16.5766 30.6072 16.2905 30.6072 16.0006C30.6072 15.7108 30.5413 15.4247 30.4145 15.164C29.4012 13.1235 28.0487 11.27 26.4145 9.68263C24.0799 7.43597 20.6439 5.3333 15.9999 5.3333C14.7361 5.3301 13.4773 5.49282 12.2559 5.8173L27.5545 21.1173V21.1173Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.09273c6ef05b7a170fe4187c39c9c78c.svg";
export { ForwardRef as ReactComponent };